export const attributeDetails = [
  {
    id: "mobile_counts",
    label: "Digital Marketing IDs:",
    unit: "#",
  },
  {
    id: "total_households",
    label: "Total Households:",
    unit: "#",
  },
  {
    id: "avg_hh_value",
    label: "Average Household value:",
    unit: "$",
  },
  {
    id: "owned",
    label: "Owned dwellings:",
    unit: "#",
  },
  {
    id: "dw_rented",
    label: "Rented dwellings:",
    unit: "#",
  },
  {
    id: "single",
    label: "Dwelling Type: Detached:",
    unit: "#",
  },
  {
    id: "semi_duplex",
    label: "Dwelling Type:Semi/Duplex:",
    unit: "#",
  },
  {
    id: "row",
    label: "Dwelling Type: Townhouse:",
    unit: "#",
  },
  {
    id: "apt",
    label: "Dwelling Type: Appt./Condo:",
    unit: "#",
  },
  {
    id: "remaining",
    label: "Dwelling Type: Others:",
    unit: "#",
  },
  {
    id: "pp_total",
    label: "Total Population:",
    unit: "#",
  },
  {
    id: "age4",
    label: "Age Bracket 0-4:",
    unit: "#",
  },
  {
    id: "age9",
    label: "Age Bracket 5-9:",
    unit: "#",
  },
  {
    id: "age14",
    label: "Age Bracket 10-14:",
    unit: "#",
  },
  {
    id: "age19",
    label: "Age Bracket 15-19:",
    unit: "#",
  },
  {
    id: "age24",
    label: "Age Bracket 20-24:",
    unit: "#",
  },
  {
    id: "age29",
    label: "Age Bracket 25-29:",
    unit: "#",
  },
  {
    id: "age34",
    label: "Age Bracket 30-34:",
    unit: "#",
  },
  {
    id: "age39",
    label: "Age Bracket 35-39:",
    unit: "#",
  },
  {
    id: "age44",
    label: "Age Bracket 40-44:",
    unit: "#",
  },
  {
    id: "age49",
    label: "Age Bracket 45-49:",
    unit: "#",
  },
  {
    id: "age54",
    label: "Age Bracket 50-54:",
    unit: "#",
  },
  {
    id: "age59",
    label: "Age Bracket 55-59:",
    unit: "#",
  },
  {
    id: "age64",
    label: "Age Bracket 60-64:",
    unit: "#",
  },
  {
    id: "age69",
    label: "Age Bracket 65-69:",
    unit: "#",
  },
  {
    id: "age74",
    label: "Age Bracket 70-74:",
    unit: "#",
  },
  {
    id: "age79",
    label: "Age Bracket 75-79:",
    unit: "#",
  },
  {
    id: "age84",
    label: "Age Bracket 80-84:",
    unit: "#",
  },
  {
    id: "age85",
    label: "Age Bracket 85+:",
    unit: "#",
  },
  {
    id: "hh_tot",
    label: "Total Households:",
    unit: "#",
  },
  {
    id: "pop_tot",
    label: "Total Population:",
    unit: "#",
  },
  {
    id: "adult_pop",
    label: "Total Adult Population:",
    unit: "#",
  },
  {
    id: "hbc_tot_wc",
    label: "HBC Womenswear:",
    unit: "$",
  },
  {
    id: "tot_exp_wc",
    label: "Womens Clothing Expenditure:",
    unit: "$",
  },
  {
    id: "hbc_tot_mc",
    label: "HBC Menswear:",
    unit: "$",
  },
  {
    id: "tot_exp_mc",
    label: "Mens Clothing Expenditure:",
    unit: "$",
  },
  {
    id: "hbc_tot_mw",
    label: "HBC Mens and Womens Wear:",
    unit: "$",
  },
  {
    id: "tot_exp_cl",
    label: "Total Clothing Expenditure:",
    unit: "$",
  },
  {
    id: "hbc_clsow_",
    label: "Clothing SOW:",
    unit: "#",
  },
  {
    id: "hbc_visit_",
    label: "Estimated Visits Potential:",
    unit: "#",
  },
  {
    id: "hbc_cust_t",
    label: "Customers:",
    unit: "#",
  },
  {
    id: "hbc_sales_",
    label: "HBC Sales:",
    unit: "$",
  },
  {
    id: "hbc_spend_",
    label: "HBC Total Spend Potential:",
    unit: "#",
  },
  {
    id: "hbc_inc_sa",
    label: "HBC Incremental Potential:",
    unit: "#",
  },
  {
    id: "hbc_pot_pe",
    label: "HBC Potential Penetration:",
    unit: "#",
  },
];
